import React, { useState } from 'react';

const TicketSearch = () => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [message, setMessage] = useState('');

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!query.trim()) {
      setMessage('Please enter something to search.');
      setResults([]);
      return;
    }

    try {
      const response = await fetch(`https://register.tjdstore.in/api/search_ticket.php?query=${encodeURIComponent(query)}`);
      const data = await response.json();

      if (data.error) {
        setMessage(data.error);
        setResults([]);
      } else if (data.length === 0) {
        setMessage('No tickets found.');
        setResults([]);
      } else {
        setMessage('');
        setResults(data);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setMessage('Error fetching data.');
    }
  };

  const handleCheckIn = async (order_id) => {
    if (!window.confirm('Mark this ticket as Checked In?')) return;

    try {
      const response = await fetch('https://register.tjdstore.in/api/checkin_ticket.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ order_id }),
      });
      const data = await response.json();

      if (data.success) {
        alert('✅ ' + data.message);
        // Update status in UI
        setResults(results.map(r => r.order_id === order_id ? { ...r, check_status: 'Checked In' } : r));
      } else {
        alert('❌ ' + data.message);
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Something went wrong.');
    }
  };

  return (
        <div className="content mt-5">
      <div className="row">
        <div className="col-lg-12 col-md-12 mt-5 wel-sec"></div>
    <div style={{ padding: '20px', fontFamily: 'Segoe UI' }}>
      <h2>🎟️ Ticket Search & Check-In</h2>
      <form onSubmit={handleSearch}>
        <input
          type="text"
          placeholder="Search by Order ID, Name, Email, Category, or Mobile"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          style={{
            padding: '10px',
            width: '320px',
            borderRadius: '5px',
            border: '1px solid #ccc',
          }}
        />
        <button
          type="submit"
          style={{
            marginLeft: '10px',
            padding: '10px 15px',
            border: 'none',
            backgroundColor: '#007bff',
            color: '#fff',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
        >
          Search
        </button>
      </form>

      {message && <p style={{ marginTop: '15px', color: 'gray' }}>{message}</p>}

      {results.length > 0 && (
        <table
          style={{
            width: '100%',
            marginTop: '20px',
            borderCollapse: 'collapse',
          }}
        >
          <thead>
            <tr style={{ background: '#007bff', color: 'white' }}>
              <th style={{ padding: '10px', border: '1px solid #ddd' }}>Order ID</th>
              <th style={{ padding: '10px', border: '1px solid #ddd' }}>Name</th>
              <th style={{ padding: '10px', border: '1px solid #ddd' }}>Email</th>
              <th style={{ padding: '10px', border: '1px solid #ddd' }}>Category</th>
              <th style={{ padding: '10px', border: '1px solid #ddd' }}>Reference</th>              
              <th style={{ padding: '10px', border: '1px solid #ddd' }}>Mobile</th>
              <th style={{ padding: '10px', border: '1px solid #ddd' }}>Status</th>
              <th style={{ padding: '10px', border: '1px solid #ddd' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {results.map((ticket, index) => (
              <tr key={index}>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>{ticket.order_id}</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>{ticket.name}</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>{ticket.email}</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>{ticket.ticket_cat}</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>{ticket.reference}</td>                
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>{ticket.mobile}</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                  {ticket.check_status || 'Pending'}
                </td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                  {ticket.check_status === 'Checked In' ? (
                    <button
                      style={{
                        padding: '6px 12px',
                        border: 'none',
                        backgroundColor: 'gray',
                        color: 'white',
                        borderRadius: '5px',
                        cursor: 'not-allowed',
                      }}
                      disabled
                    >
                      ✅ Checked In
                    </button>
                  ) : (
                    <button
                      onClick={() => handleCheckIn(ticket.order_id)}
                      style={{
                        padding: '6px 12px',
                        border: 'none',
                        backgroundColor: '#28a745',
                        color: 'white',
                        borderRadius: '5px',
                        cursor: 'pointer',
                      }}
                    >
                      Check-In
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
        </div>
            </div>
  );
};

export default TicketSearch;
